// src/components/layout/WrapperRoute.jsx
import React from 'react';
import { Outlet } from 'react-router-dom';
import Layout from './Layout';

const WrapperRoute = () => {
  return (
    <Layout>
      <Outlet />
    </Layout>
  );
};

export default WrapperRoute;
